import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";
import { encryptApiKey, decryptApiKey } from "../../util/crypt";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqCredenciais = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/credenciais", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listID: async function (id) {
		return apiServer
			.get(`portal/v1/credenciais/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				// Descriptografa ao receber do servidor
				if (response.data && response.data.api_key) {
					response.data.api_key = decryptApiKey(response.data.api_key);
				}
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	insert: async function (data) {
		// Criptografa antes de enviar ao servidor
		const dataToSend = { ...data };
		if (dataToSend.api_key) {
			dataToSend.api_key = encryptApiKey(dataToSend.api_key);
		}

		return apiServer
			.post("portal/v1/credenciais", dataToSend, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listAll: async function () {
		return apiServer
			.get("portal/v1/credenciais/all", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listTipos: async function () {
		return apiServer
			.get("portal/v1/credenciais/tipos", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqCredenciais;
